import lb from '@/lib/loopback';

export function countAccounts() {
  return lb
    .get('/Accounts/count')
    .then(res => res.count);
}

export function findAccounts(settings = {}) {
  return lb
    .find('/Accounts/', settings)
    .then(data => data);
}

export function findAccount(id, settings = {}) {
  return lb
    .find(`/Accounts/${id}`, settings)
    .then(data => data);
}

export function removeAccount(id) {
  return lb.delete(`/Accounts/${id}`);
}

export function updateAccount(account) {
  return lb.patch(`/Accounts/${account.id}`, account);
}

export function createAccount(account, role) {
  return lb.post('/Accounts', account, {
    headers: {
      role,
    },
  });
}

export function updateAccountRole({ id, role }) {
  return lb.get(`/Accounts/${id}/roleMapping`)
    .then((rlMp) => {
      // pressupõe apenas uma permissão por usuário
      // apesar do backend permitir mais de uma
      rlMp[0].roleId = role;
      return lb.put(`/Accounts/${id}/roleMapping/${rlMp[0].id}`, rlMp[0]);
    });
}

export default {
  countAccounts,
  findAccounts,
  removeAccount,
  updateAccount,
  createAccount,
  findAccount,
  updateAccountRole,
};
